import { Link } from "@inertiajs/react";

type Props = {
  notes: {
    id: string;
    body: string;
  }[];
};

export default function Index({ notes }: Props) {
  return (
    <ul>
      {notes.map((note) => (
        <li key={note.id}>
          <Link href={`/notes/${note.id}`}>{note.body}</Link>
        </li>
      ))}
    </ul>
  );
}
